import PaymentCardsOnFile from './PaymentCardsOnFile';
export default PaymentCardsOnFile;
